import React from 'react'
import { Link } from 'react-router-dom';
import logoonlinepaathshala from '../images/bgremovedlogo.png';

export default function Footer() {
  return (
    <footer className="bg-black text-white border-t border-gray-300 py-4 shadow">
    <div className="max-w-7xl mx-auto px-4 grid grid-cols-1  gap-6 items-center text-center  lg:text-center">
     
      {/* Middle: Links */}
      <div className="flex justify-center ">
        <ul className="flex gap-4">
          <li><Link to="/" className=" hover:text-blue-600 font-semibold">Home</Link></li>
          <li><Link to="/samplepappers" className=" hover:text-blue-600 font-semibold">Sample Paper</Link></li>
          <li><Link to="/courses" className=" hover:text-blue-600 font-semibold">Courses</Link></li>
          <li><Link to="/notes" className=" hover:text-blue-600 font-semibold">Notes</Link></li>
          <li><Link to="/contact" className=" hover:text-blue-600 font-semibold">About</Link></li>
        </ul>
      </div>

      {/* Right: Developer Info */}
      <div className="flex flex-col  ">
        <p >Developed by <span className="font-semibold">Er. Bibek Regmi</span></p>
        <p className="text-sm ">© {new Date().getFullYear()} All Rights Reserved</p>
      </div>
    </div>
  </footer>
  )
}
